import { render, staticRenderFns } from "./HistorialPacientes.vue?vue&type=template&id=95d2986e&scoped=true&"
import script from "./HistorialPacientes.vue?vue&type=script&lang=js&"
export * from "./HistorialPacientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d2986e",
  null
  
)

export default component.exports